<template>
  <header
      id="header"
      :class="['header', { 'header--sticky': sticky}]"
      v-signal
      v-xlead="geo.state"
      :data-vssr="glb.isSSR"
  >
    <!-- Semi-Transparent Overlay for Mobile Navigation -->
    <div class="header-overlay" @click="toggleMenu(false)"></div>
    <!-- Logo & Search Bar -->
    <mvtHeaderLogo
        :disableSearch="disableSearch"
        @toggleMenu="toggleMenu"
    >
      <!-- Search Bar -->
      <div class="header-bar-search" v-if="!disableSearch">
        <mvtSearchbox
            class="fullscreen"
            id="textboxGeo"
            ref="autocomplete"
            :placeholder="'City, ZIP, School, Address, Neighborhood'"
            v-model="searchInfo"
        />
      </div>
    </mvtHeaderLogo>
    <!-- Navigation Menu -->
    <div class="header-nav">
      <ul class="header-menu-list">
        <!-- Mobile Logo -->
        <a
            :href="glb.appUrl"
            v-if="expand"
            title="Movoto Logo"
            class="header-menu-logo"
        >
          <img :src="glb.cdnUrl + 'vimages/movoto-lower-logo.svg'" alt="Movoto Logo" />
        </a>
        <!-- Guest User Sign-In / Join & Authenticated User Menu -->
        <mvtHeaderMenuAuth
            :user="glb.user"
            :activeDropdown="activeDropdownIndex"
            @dropdownSelected="setActiveDropdownIndex"
        />
        <!-- Primary Menu -->
        <mvtHeaderMenuPrimary
            :geo="geo"
            :activeDropdown="activeDropdownIndex"
            @dropdownSelected="setActiveDropdownIndex"
        />
        <!-- Notification + Feed -->
        <mvtHeaderNotifications v-if="isMounted" />
        <!-- Phone & Contact -->
        <mvtHeaderContact />
      </ul>
    </div>
    <a id="cmlink1" style="display: none" href="javascript:;" role="button"></a>
  </header>
</template>

<script src="./mvt-header.js"></script>

<style lang="scss">
@use "./mvt-header.scss" as *;
</style>
